import axios from 'axios';
export default{
    state: {
        storeProducts: [],
    },

    getters: {
        storeInformations: state => {
            return state.storeProducts
        },

        getProductsAmount: state => {
            return state.storeProducts.length
        },

        getTotalPrice: state => {
            let totalPrice = 0;
            for ( let product of state.storeProducts){
                totalPrice += product.price * product.quantity
            }

            return totalPrice.toFixed(2);
        },

        getStoreProuctById: state => id => {
            return state.storeProducts.find(product => product.id === id)
        },

        getStoreProuctIndex: state => id => {
            return state.storeProducts.findIndex(product => product.id === id)
        },

        getProductsWithBasket: state => id => {
            return state.products;
        }
    },

    mutations: {
        ADD_STORE_PRODUCT: (state, product) => {
            state.storeProducts.push(product);
        },

        pushProduct: (state, product) => {
            state.products.push(product);
        },

        EDIT_STORE_PRODUCT: (state, data) => {
            data.cartItem.quantity = data.product.quantity
        },

        CHANGE_PRICE_STORE_PRODUCT: (state, data) => {
            data.cartItem.price = data.product.price
        },

        EDIT_PRODUCT: (state, data) => {
            data.product.quantity = data.cartItem.quantity
        },

        REMOVE_STORE_PRODUCT: (state, index) => {
            state.storeProducts.splice(index, 1)
        },

        RESET_STORE_PRODUCTS: (state) => {
            state.storeProducts = [];
        }
    },

    actions: {

        async checkProduct({commit, getters}, product) {
            const cartItem = getters.getStoreProuctById(product.id);
            if (cartItem){
                if (product.quantity > 0){
                    commit('EDIT_STORE_PRODUCT', {cartItem: cartItem, product: product})
                }else{
                    const cartItemIndex = getters.getStoreProuctIndex(product.id);
                    commit('REMOVE_STORE_PRODUCT', cartItemIndex)
                }
            }else{
                commit('ADD_STORE_PRODUCT', product)
            }
        },

        removeProduct({commit, getters}, product) {
            const cartItem = getters.getStoreProuctById(product.id);
            if (cartItem){
                const cartItemIndex = getters.getStoreProuctIndex(product.id);
                commit('REMOVE_STORE_PRODUCT', cartItemIndex)
            }
        },

        pushProductsWithBasket({getters, commit}, data) {
            const pr = [];
            data.products.forEach((product) => {
                const cartItem = getters.getStoreProuctById(product.id);
                if (cartItem){
                    product.quantity = cartItem.quantity
                }else {
                    product.quantity = 0
                }

                pr.push(product)
            })

            return pr;
        },

        pushProductWithBasket({getters, commit}, data) {
            let product = data.product
            const cartItem = getters.getStoreProuctById(product.id);
            if (cartItem){
                product.quantity = cartItem.quantity
            }else {
                product.quantity = 0
            }

            return product;
        },

        changeProductsWithBasket({state, getters, commit}, data) {

            state.storeProducts.forEach((cartItem) => {
                const product = data.products.find(product => product.id === cartItem.id );
                if (product){
                    commit('CHANGE_PRICE_STORE_PRODUCT', {cartItem: cartItem, product: product})
                }else {
                    const cartItemIndex = getters.getStoreProuctIndex(cartItem.id);
                    commit('REMOVE_STORE_PRODUCT', cartItemIndex)
                }
            })
        },
    },
}



// WEBPACK FOOTER //
// ./src/store/basket.js